/** @flow */
import React from 'react';
import styled, { withTheme } from 'styled-components';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { DropdownItem } from 'common/components/ui/Dropdown';
import Card from './Card';

const SCard = styled(Card)`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export type Item = DropdownItem<any>;

export type Props = {
  textColor: string,
  selectedTextColor: string,
  items: Array<Item>,
  value: any,
  hintText?: string;
  errorText?: any,
  theme: Object,
  icon?: () => any,
  onChange: (value: any) => any,
  extraCardStyle?: Object,
  extraTextStyle?: Object,
};

function generateKey(item: Item): string {
  const value = JSON.stringify(item.value);
  return `${item.label}_${value}_${new Date().getTime()}`;
}

function DropDownMenu(props: Props) {
  const { icon, extraCardStyle, extraTextStyle } = props;

  return (
    <SCard style={{ paddingBottom: props.errorText && props.theme.metrics.margin, ...extraCardStyle }}>
      {icon && Boolean(icon) && icon()}
      <SelectField
        value={props.value}
        onChange={(event, index, value) => props.onChange(value)}
        underlineStyle={{ height: 0, borderColor: 'transparent' }}
        hintText={props.hintText}
        errorText={props.errorText}
        fullWidth
        selectedMenuItemStyle={{
          color: props.selectedTextColor,
          fontSize: '1rem',
          ...extraTextStyle,
        }}
        labelStyle={{
          color: props.textColor,
          fontSize: '1rem',
          paddingLeft: props.theme.metrics.margin,
          paddingRight: props.theme.metrics.margin,
          ...extraTextStyle,
        }}
        hintStyle={{
          color: props.textColor,
          fontSize: '1rem',
          paddingLeft: props.theme.metrics.margin,
          paddingRight: props.theme.metrics.margin,
          ...extraTextStyle,
        }}
        menuItemStyle={{
          color: props.textColor,
          fontSize: '1rem',
          ...extraTextStyle,
        }}
        style={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {props.items.map(item =>
          <MenuItem
            key={generateKey(item)}
            primaryText={item.label}
            value={item.value}
          />,
        )}
      </SelectField>
    </SCard>
  );
}

export default withTheme(DropDownMenu);



// WEBPACK FOOTER //
// ./src/common/components/DropDownMenu.js